import { Result } from "@lib/result";

import { CompanySettingsApiService } from "@api-services/company/CompanySettingsApiService";
import { ActivationResponse, ActivationErrorResponse } from "@data-types";
import { AccountActivationRequestDto } from "@api-types/user/AccountActivationRequestDto";
import { LoginResponseDto } from "@api-types/user/LoginResponseDto";

import { getCurrentCulture } from "@utils";
import { LazyImportWithLoadFailHandle as lazy } from "@lib/lazy-import-with-guard/LazyImportWithGuard";

const loadFailPath = `/${getCurrentCulture()}/app-update`;

// prettier-ignore
const UserApiService = lazy(loadFailPath, ()=>import("@api-services/user/UserApiService"));
// prettier-ignore
const AgencyUserApiService = lazy(loadFailPath, ()=>import("@api-services/user/AgencyUserApiService"));

export default class AccountActivationService {
	static async getAccountActivationData(
		accountActivationToken: string,
		agencyId: string
	): Promise<Result<ActivationResponse, any>> {
		try {
			const userInfo = await (
				await AgencyUserApiService
			).default.getCardUserInfoAsync(accountActivationToken, agencyId);
			const companyInfo =
				await CompanySettingsApiService.getLimitedCompanySettings();

			return new Result(
				new ActivationResponse(userInfo, companyInfo),
				null
			);
		} catch (error) {
			return new Result<ActivationResponse, any>(null, error);
		}
	}

	static async createAccountActivation(
		activationModel: AccountActivationRequestDto
	): Promise<Result<LoginResponseDto, ActivationErrorResponse>> {
		try {
			const response = await (
				await UserApiService
			).default.accountActivation(activationModel);
			return new Result<LoginResponseDto, ActivationErrorResponse>(
				response,
				null
			);
		} catch (error) {
			console.error(error);

			let errorMessage = null;
			let userData = null;

			switch (error?.data?.errorCode) {
				case 400213:
					errorMessage = "GENERIC_ERROR";
					userData = error?.data;
				case 400170:
					errorMessage = "ERROR_PWD_CHANGE_CURRENT_SAME";
					break;

				case 400171:
					errorMessage = "ERROR_PWD_CHANGE_OLD_SAME";
					break;

				case 400141:
					errorMessage = "AUTO_LOGOUT_DISABLE_ERROR";
					break;

				case 400165:
					errorMessage = "ERROR_PWD_CHANGE_SIMILAR";
					break;

				default:
					errorMessage = "GENERIC_ERROR";
					break;
			}

			return new Result<LoginResponseDto, ActivationErrorResponse>(
				null,
				new ActivationErrorResponse(errorMessage, error, userData)
			);
		}
	}
}
